import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { msalInstance } from './app/core/auth/config/msal';

msalInstance.initialize().then(() => {
  msalInstance.handleRedirectPromise()
    .finally(() => {
      bootstrapApplication(App, appConfig).catch((err) => console.error(err));
    });
});
